import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { StateStatusCssClasses } from "../StatesUIHelpers";
import * as actions from "../../../_redux/states/statesActions";
import { useStatesUIContext } from "../StatesUIContext";

const selectedStates = (entities, ids) => {
  const _states = [];
  ids.forEach((id) => {
    const state = entities.find((el) => el.id === id);
    if (state) {
      _states.push(state);
    }
  });
  return _states;
};

export function StatesUpdateStatusDialog({ show, onHide }) {
  // States UI Context
  const statesUIContext = useStatesUIContext();
  const statesUIProps = useMemo(() => {
    return {
      ids: statesUIContext.ids,
      setIds: statesUIContext.setIds,
      queryParams: statesUIContext.queryParams,
    };
  }, [statesUIContext]);

  // States Redux state
  const { states, isLoading } = useSelector(
    (state) => ({
      states: selectedStates(state.states.entities, statesUIProps.ids),
      isLoading: state.states.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected states we should close modal
  useEffect(() => {
    if (!statesUIProps.ids || statesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statesUIProps.ids]);

  const [status, setStatus] = useState("active");

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updating state by ids
    dispatch(actions.updateStatesStatus(statesUIProps.ids, status)).then(
      () => {
        // refresh list after update
        dispatch(actions.fetchStates(statesUIProps.queryParams)).then(
          () => {
            // clear selections list
            statesUIProps.setIds([]);
            // closing modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="state-status-modal-title"
    >
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="state-status-modal-title" className="font-weight-bolder text-dark">
          Update Status for Selected States
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="alert alert-custom alert-light-primary fade show mb-4 py-3 px-4 d-flex align-items-center" role="alert">
          <div className="alert-icon mr-3">
            <i className="fa fa-info-circle text-primary font-size-h5"></i>
          </div>
          <div className="alert-text font-size-sm text-dark font-weight-bold">
            Updating status for <span className="text-primary font-size-lg font-weight-bolder">{statesUIProps.ids.length}</span> selected states.
          </div>
        </div>

        <div className="form-group mb-2">
          <label className="font-weight-bold text-dark font-size-sm mb-2">
            Change Status To
          </label>
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={updateStatus}
          className="btn btn-primary font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Updating...
            </>
          ) : (
            "Update Status"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
